import createExternalStore from "../../../../common/utils/createExternalStore";
import { CORE_API_HOSTNAME } from "../../../../env";
import fulfill from "../../../../fulfill";

type PutOverrideAction = {
    accountId: string;
    storeId: string;
    gateway: string;
    credentials: Record<string, string | undefined>;
};

interface State {
    isLoading: boolean;
    error: boolean;
    recentlyOverridenGateways: {
        [locationId: string]: string[] | undefined;
    };
}

const initialState: State = {
    isLoading: false,
    error: false,
    recentlyOverridenGateways: {},
};

export const overriddenGatewaysStore = createExternalStore(
    initialState,
    {
        putOverride: (state, action: PutOverrideAction) => {
            return {
                ...state,
                isLoading: true,
            };
        },
        putOverrideResponse: (state, action: PutOverrideAction) => {
            const { storeId } = action;
            const newOverridenGateways = {
                ...state.recentlyOverridenGateways,
                [storeId]: [
                    ...(state.recentlyOverridenGateways[storeId] || []),
                    action.gateway,
                ],
            };
            return {
                ...state,
                isLoading: false,
                recentlyOverridenGateways: newOverridenGateways,
            };
        },
    },
    "overriddenGatewaysStore",
);

export const effects = {
    putOverride: async (payload: {
        accountId: string;
        storeId: string;
        gateway: string;
        credentials: Record<string, string | undefined>;
    }) => {
        const { accountId, gateway, storeId, credentials } = payload;
        const result = await fulfill.put({
            accountId,
            url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/management/settings/connections/${gateway}/overrides`,
            json: {
                overrides: [
                    {
                        store_id: storeId,
                        credentials,
                    },
                ],
            },
            handlers: {
                200: () =>
                    overriddenGatewaysStore.dispatch(
                        "putOverrideResponse",
                        payload,
                    ),
            },
        });
        return result;
    },
};

export const actions = {
    putOverride: (
        accountId: string,
        storeId: string,
        gateway: string,
        credentials: Record<string, string | undefined>,
    ) => {
        overriddenGatewaysStore.dispatch("putOverride", {
            accountId,
            storeId,
            gateway,
            credentials,
        });
    },
};
